import React, { useEffect, useState } from 'react'
import { Heading, Text } from '../../components/ui'
import { PermissionGuard } from '../../components/PermissionGuard'
import { modulesService } from '../../services/modules'
import GameCadastroTab from './GameCadastroTab'
import GameRankingTab from './GameRankingTab'
import GameRankingHistoricoTab from './GameRankingHistoricoTab'

const MODULE_NAME = 'marketing_game'
const PERM_LOADING: React.ReactNode = null

type ActiveTab = 'cadastrar' | 'ranking' | 'historico'

const tabClass = (activeTab: ActiveTab, tab: ActiveTab) =>
  `py-3 px-1 border-b-2 font-medium text-sm ${
    activeTab === tab
      ? 'border-primary-600 text-primary-600 dark:text-primary-400'
      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-200'
  }`

const MarketingGamePage: React.FC = () => {
  const [moduleTitle, setModuleTitle] = useState('Caça-Palavras')
  const [moduleDescription, setModuleDescription] = useState(
    'Cadastre edições, jogue o caça-palavras e acompanhe o ranking'
  )
  const [activeTab, setActiveTab] = useState<ActiveTab>('cadastrar')

  useEffect(() => {
    modulesService.getByName(MODULE_NAME).then((result) => {
      if (result.success && result.data) {
        if (result.data.display_name) setModuleTitle(result.data.display_name)
        if (result.data.description) setModuleDescription(result.data.description)
      }
    })
  }, [])

  return (
    <div className="flex-1 flex flex-col overflow-x-hidden overflow-y-auto">
        <PermissionGuard
          moduleName={MODULE_NAME}
          permissionType="show"
          loadingComponent={PERM_LOADING}
        >
          <div className="py-6 px-4 sm:px-6 lg:px-8">
            <div className="mb-6">
              <Heading as="h1" size="3xl" className="text-gray-900 dark:text-white">
                {moduleTitle}
              </Heading>
              <Text size="sm" color="muted" className="mt-2">
                {moduleDescription}
              </Text>
            </div>

            <div className="mb-6 border-b border-gray-200 dark:border-gray-700">
              <nav className="-mb-px flex space-x-8">
                <PermissionGuard
                  moduleName={MODULE_NAME}
                  permissionType="insert"
                  fallback={null}
                  loadingComponent={PERM_LOADING}
                >
                  <button
                    type="button"
                    onClick={() => setActiveTab('cadastrar')}
                    className={tabClass(activeTab, 'cadastrar')}
                  >
                    Cadastrar
                  </button>
                </PermissionGuard>
                <button
                  type="button"
                  onClick={() => setActiveTab('ranking')}
                  className={tabClass(activeTab, 'ranking')}
                >
                  Ranking
                </button>
                <button
                  type="button"
                  onClick={() => setActiveTab('historico')}
                  className={tabClass(activeTab, 'historico')}
                >
                  Ranking histórico
                </button>
              </nav>
            </div>

            {activeTab === 'cadastrar' && (
              <PermissionGuard
                moduleName={MODULE_NAME}
                permissionType="insert"
                fallback={
                  <Text size="sm" color="muted">
                    Você não tem permissão para cadastrar jogos.
                  </Text>
                }
                loadingComponent={PERM_LOADING}
              >
                <GameCadastroTab />
              </PermissionGuard>
            )}
            {activeTab === 'ranking' && <GameRankingTab />}
            {activeTab === 'historico' && <GameRankingHistoricoTab />}
          </div>
        </PermissionGuard>
      </div>
  )
}

export default MarketingGamePage
